import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const AdminKeyIcon = (props: IconProps) => (
  <Icon width="24px" height="24px" viewBox="0 0 24 24" {...props}>
    <path d="M21 10.571h-8.35a5.99 5.99 0 0 0-5.65-4c-3.31 0-6 2.69-6 6s2.69 6 6 6a5.99 5.99 0 0 0 5.65-4H13l2 2 2-2 2 2 4-4.04-2-1.96Zm-14 5c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3Z" />
  </Icon>
);

export default memo(AdminKeyIcon);
